import { Grid } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import MainCard from "../../../components/common/MainCard";

const Item = () => {
  return (
    <Grid item xs={12} sm={6} md={3} lg={3} xl={2}>
      <MainCard
        height={460}
        elevation={4}
        // border={`1px solid ${theme.palette.grey[300]}`}
      >
        <Skeleton height={30} />
        <Skeleton height={30} />
        <br />
        <Skeleton />
        <Skeleton />
        <br />
        <br />
        <Skeleton />
        <Skeleton />
        <Skeleton />
        <Skeleton />
        <br />
        <br />
        <Grid item container spacing={2}>
          <Grid item xs={6}>
            <Skeleton height={70} />
          </Grid>
          <Grid item xs={6}>
            <Skeleton height={70} />
          </Grid>
        </Grid>
        <br />
        <Skeleton height={40} />
      </MainCard>
    </Grid>
  );
};

const CostosSkeleton = () => {
  return (
    <Grid container spacing={4} style={{ marginTop: 34, padding: 20 }}>
      <Item />
      <Item />
      <Item />
      <Item />
      <Item />
      <Item />
    </Grid>
  );
};

export default CostosSkeleton;
